import Vue from 'vue';
import icon from '@/components/icon.vue';
import areaSelect from '@/components/AreaSelect.vue';
import PageLayout from '@/layouts/PageLayout.vue';
import CompanySearch from '@/components/CompanySearch.vue';
import StaionQrcode from '@/components/StaionQrcode.vue';
import StationSelect from '@/components/stationSelect.vue';
import CabinetGridTreeSelect from '@/components/CabinetGridTreeSelect.vue';
import ExcomIcon from '@/components/excomIcon.vue';
import CabinetStatus from '@/components/cabinetStatus.vue';
import UserSearch from '@/components/UserSearch.vue';
import DeviceSelect from '@/components/DeviceSelect.vue';
import DtuStatus from '@/components/DtuStatus.vue';

Vue.component('icon', icon);
Vue.component('page-layout', PageLayout);
Vue.component('area-select', areaSelect);
Vue.component('company-search', CompanySearch);
Vue.component('staion-qrcode', StaionQrcode);
Vue.component('station-select', StationSelect);
Vue.component('cabinet-grid-tree-select', CabinetGridTreeSelect);
Vue.component('excom-icon', ExcomIcon);
Vue.component('cabinet-status', CabinetStatus);
Vue.component('user-search', UserSearch);
Vue.component('device-select', DeviceSelect);
Vue.component('dtu-status', DtuStatus);
